import { useState, useEffect, useContext } from "react";
import {
    Grid,
    TextField,
} from '@mui/material';
import { ActionContext } from 'src/contexts/ActionContext';
import { Trans, useTranslation } from 'react-i18next';
import { BusinessManagerContext } from "src/contexts/BusinessManagerContext";

function EmployeeIdentity(props) {
    const { t } = useTranslation();
    const { actionToggle } = useContext(ActionContext);
    const { eepBMData } = useContext(BusinessManagerContext);
    const isVisu = !actionToggle;
    const [data, setData] = useState({
        lastName: '',
        firstName: '',
        birthDate: '',
        hireDate: '',
        manager: '',
        interviewDate: '',
        year: '',
        interviewDatePrevYear: '',
        position: '',
        entity: '',
        functionEntryDate: '',
        degree: '',
        degreeObtainPeriod: '',
        experience: 0,
    });

    useEffect(() => {
        if (props.data != undefined) {
            setData({
                lastName: props.data.lastName,
                firstName: props.data.firstName,
                birthDate: props.data.birthDate,
                hireDate: props.data.hireDate,
                manager: props.data.manager,
                interviewDate: props.data.interviewDate,
                year: props.data.year,
                interviewDatePrevYear: props.data.interviewDatePrevYear,
                position: props.data.position,
                entity: props.data.entity,
                functionEntryDate: props.data.functionEntryDate,
                degree: props.data.degree,
                degreeObtainPeriod: props.data.degreeObtainPeriod,
                experience: props.data.experience,
            })
        }
    }, [props.data]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    const setDataContextValue = () => {
        eepBMData.interviewDate = data.interviewDate;
        eepBMData.year = data.year;
        eepBMData.interviewDatePrevYear = data.interviewDatePrevYear;
        eepBMData.position = data.position;
        eepBMData.entity = data.entity;
        eepBMData.functionEntryDate = data.functionEntryDate;
        eepBMData.experience = data.experience;
    }

    return (
        <>
            <div style={{ backgroundColor: '#ffffff', marginTop: -10 }} >
                <Grid item xs={12} >
                    <h3 style={{
                        backgroundColor: '#006976',
                        color: '#ffffff',
                        height: 50,
                        paddingTop: 14,
                        paddingLeft: 10,
                        borderRadius: 3,
                        fontSize: 13, textTransform: 'uppercase',
                    }}><Trans>eepBm.subTab11.label</Trans></h3>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.subTab11.field1')}
                            type="text"
                            variant="outlined"
                            name="lastName"
                            value={data.lastName}
                            fullWidth
                            // onChange={handleChange}
                            // onBlur={setDataContextValue}
                            disabled
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.subTab11.field2')}
                            type="text"
                            variant="outlined"
                            name="firstName"
                            value={data.firstName}
                            fullWidth
                            // onChange={handleChange}
                            // onBlur={setDataContextValue}
                            disabled
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.subTab11.field3')}
                            InputLabelProps={{ shrink: true, focused: true, style: { color: 'rgba(34, 51, 84, 0.5)' } }}
                            type="date"
                            variant="outlined"
                            name="birthDate"
                            value={data.birthDate}
                            fullWidth
                            // onChange={handleChange}
                            // onBlur={setDataContextValue}
                            disabled
                        // onKeyDown={(e) => {
                        //     e.preventDefault();
                        // }}
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.subTab11.field4')}
                            InputLabelProps={{ shrink: true, focused: true, style: { color: 'rgba(34, 51, 84, 0.5)' } }}
                            type="date"
                            variant="outlined"
                            name="hireDate"
                            value={data.hireDate}
                            fullWidth
                            // onChange={handleChange}
                            // onBlur={setDataContextValue}
                            disabled
                        // onKeyDown={(e) => {
                        //     e.preventDefault();
                        // }}
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.subTab11.field5')}
                            type="text"
                            variant="outlined"
                            name="manager"
                            value={data.manager}
                            fullWidth
                            // onChange={handleChange}
                            // onBlur={setDataContextValue}
                            disabled
                        />
                    </Grid>
                </Grid>
            </div>
            <div style={{ backgroundColor: '#ffffff', marginTop: -10 }} >
                <Grid item xs={12} >
                    <h3 style={{
                        backgroundColor: '#006976',
                        color: '#ffffff',
                        height: 50,
                        paddingTop: 14,
                        paddingLeft: 10,
                        borderRadius: 3,
                        fontSize: 13, textTransform: 'uppercase',
                    }}><Trans>eepBm.subTab12.label</Trans></h3>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.subTab12.field1')}
                            InputLabelProps={{ shrink: true, focused: true, style: { color: 'rgba(34, 51, 84, 0.5)' } }}
                            type="date"
                            variant="outlined"
                            name="interviewDate"
                            value={data.interviewDate}
                            fullWidth
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.subTab12.field2')}
                            type="text"
                            variant="outlined"
                            name="year"
                            value={data.year}
                            fullWidth
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            disabled={isVisu}
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.subTab12.field3')}
                            InputLabelProps={{ shrink: true, focused: true, style: { color: 'rgba(34, 51, 84, 0.5)' } }}
                            type="date"
                            variant="outlined"
                            name="interviewDatePrevYear"
                            value={data.interviewDatePrevYear}
                            fullWidth
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.subTab12.field4')}
                            type="text"
                            variant="outlined"
                            name="manager"
                            value={data.manager}
                            fullWidth
                            // onChange={handleChange}
                            // onBlur={setDataContextValue}
                            disabled
                        />
                    </Grid>
                </Grid>
            </div>
            <div style={{ backgroundColor: '#ffffff', marginTop: -10 }} >
                <Grid item xs={12} >
                    <h3 style={{
                        backgroundColor: '#006976',
                        color: '#ffffff',
                        height: 50,
                        paddingTop: 14,
                        paddingLeft: 10,
                        borderRadius: 3,
                        fontSize: 13, textTransform: 'uppercase',
                    }}><Trans>eepBm.subTab13.label</Trans></h3>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={6} >
                        <TextField
                            label={t('eepBm.subTab13.field1')}
                            type="text"
                            variant="outlined"
                            name="position"
                            value={data.position}
                            fullWidth
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            disabled={isVisu}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            label={t('eepBm.subTab13.field2')}
                            type="text"
                            variant="outlined"
                            name="entity"
                            value={data.entity}
                            fullWidth
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            disabled={isVisu}
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.subTab13.field3')}
                            InputLabelProps={{ shrink: true, focused: true, style: { color: 'rgba(34, 51, 84, 0.5)' } }}
                            type="date"
                            variant="outlined"
                            name="functionEntryDate"
                            value={data.functionEntryDate}
                            fullWidth
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={6} >
                        <TextField
                            label={t('eepBm.subTab13.field4')}
                            type="text"
                            variant="outlined"
                            name="degree"
                            value={data.degree}
                            fullWidth
                            // onChange={handleChange}
                            // onBlur={setDataContextValue}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            label={t('eepBm.subTab13.field5')}
                            type="text"
                            variant="outlined"
                            name="degreeObtainPeriod"
                            value={data.degreeObtainPeriod}
                            fullWidth
                            // onChange={handleChange}
                            // onBlur={setDataContextValue}
                            disabled
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.subTab13.field6')}
                            type="number"
                            variant="outlined"
                            name="experience"
                            value={data.experience}
                            fullWidth
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            disabled={isVisu}
                        />
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default EmployeeIdentity;